import { Parameter } from './parameter.model';

export interface PlantModelParameter extends Parameter {
  /**
   * Belongs to Device [FK].
   */
  deviceSerialNumber: string;
}

export const plantModelTemplateParameters: Partial<PlantModelParameter>[] = [
  {
    defaultData: 0,
    fieldName: 'identifiedMomentOfInertia',
    floatValue: 0,
    group: 'Plant Model',
    hidden: false,
    inputType: 'number',
    mandatory: true,
    min: 0,
    name: 'Identified Moment of Inertia',
    typeValue: 'floatValue',
    unit: 'kg m^2',
    unitConverterId: 'inertia',
    value: 0,
    writeAccess: false,
  },
  {
    defaultData: 0,
    fieldName: 'identifiedViscousFrictionConstant',
    floatValue: 0,
    group: 'Plant Model',
    hidden: false,
    inputType: 'number',
    mandatory: true,
    min: 0,
    name: 'Identified Viscous Friction Constant',
    typeValue: 'floatValue',
    unit: 'Nm/(rad/s)',
    unitConverterId: 'friction',
    value: 0,
    writeAccess: false,
  },
];
